import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const NavBar = ({ className, children, isSticky }) => {
    return (
        <div
            className={classNames(
                'z-40 w-full text-white transition-all duration-300',
                'relative',
                isSticky ? 'sticky top-0' : 'relative',
                className
            )}
        >
            {children}
            {/* Subtle bottom edge — calmer than gradient */}
            <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'var(--border-divider)' }} />
        </div>
    );
};

NavBar.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    isSticky: PropTypes.bool,
};

NavBar.defaultProps = {
    isSticky: false,
};

export default NavBar;
